export default __webpack_public_path__ + "maps-examples-data-driven-symbols-thumbnail-480-9e7378cb5816179cb9f5a4a4912306ab.webp";